/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
export var BoundingBox = {
    serializedName: "BoundingBox",
    type: {
        name: "Composite",
        className: "BoundingBox",
        modelProperties: {
            left: {
                required: true,
                nullable: false,
                serializedName: "left",
                type: {
                    name: "Number"
                }
            },
            top: {
                required: true,
                nullable: false,
                serializedName: "top",
                type: {
                    name: "Number"
                }
            },
            width: {
                required: true,
                nullable: false,
                serializedName: "width",
                type: {
                    name: "Number"
                }
            },
            height: {
                required: true,
                nullable: false,
                serializedName: "height",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var CustomVisionError = {
    serializedName: "CustomVisionError",
    type: {
        name: "Composite",
        className: "CustomVisionError",
        modelProperties: {
            code: {
                required: true,
                serializedName: "code",
                type: {
                    name: "String"
                }
            },
            message: {
                required: true,
                serializedName: "message",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var Prediction = {
    serializedName: "Prediction",
    type: {
        name: "Composite",
        className: "Prediction",
        modelProperties: {
            probability: {
                nullable: false,
                readOnly: true,
                serializedName: "probability",
                type: {
                    name: "Number"
                }
            },
            tagId: {
                nullable: false,
                readOnly: true,
                serializedName: "tagId",
                type: {
                    name: "Uuid"
                }
            },
            tagName: {
                nullable: true,
                readOnly: true,
                serializedName: "tagName",
                type: {
                    name: "String"
                }
            },
            boundingBox: {
                nullable: true,
                readOnly: true,
                serializedName: "boundingBox",
                type: {
                    name: "Composite",
                    className: "BoundingBox"
                }
            },
            tagType: {
                nullable: true,
                readOnly: true,
                serializedName: "tagType",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var ImagePrediction = {
    serializedName: "ImagePrediction",
    type: {
        name: "Composite",
        className: "ImagePrediction",
        modelProperties: {
            id: {
                nullable: false,
                readOnly: true,
                serializedName: "id",
                type: {
                    name: "Uuid"
                }
            },
            project: {
                nullable: false,
                readOnly: true,
                serializedName: "project",
                type: {
                    name: "Uuid"
                }
            },
            iteration: {
                nullable: false,
                readOnly: true,
                serializedName: "iteration",
                type: {
                    name: "Uuid"
                }
            },
            created: {
                nullable: false,
                readOnly: true,
                serializedName: "created",
                type: {
                    name: "DateTime"
                }
            },
            predictions: {
                readOnly: true,
                serializedName: "predictions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "Prediction"
                        }
                    }
                }
            }
        }
    }
};
export var ImageUrl = {
    serializedName: "ImageUrl",
    type: {
        name: "Composite",
        className: "ImageUrl",
        modelProperties: {
            url: {
                required: true,
                nullable: false,
                serializedName: "url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
//# sourceMappingURL=mappers.js.map